import {arabic2hindi, markdownToHtml} from "@/lib/funclib";
import {Cardset} from "@/models/Cardset";

export default {
    data () {
        return {
            cardset: new Cardset(),
        }
    },
    methods: {
        toHtml(text, lang) {
            return markdownToHtml(text, lang)
        },
        langCss (lang) {
            return 'lang-' + lang.toUpperCase() + ' component-' + lang.toUpperCase();
        },
        fetchCardset (pk) {
            if (this.$store.getters.hasCardset(pk)) {
                this.cardset = this.$store.getters.getCardset(pk);
                // eslint-disable-next-line no-unused-vars
                return new Promise((resolutionFunc, rejectionFunc) => {
                    resolutionFunc(true);
                })
            }
            let that = this;
            return this.cardset.api.fetch(pk).then(function () {
                that.$store.commit('storeCardset', that.cardset);
                that.$store.commit('setCurrentCardset', that.cardset);
            });
        },
        a2h (text) {
            return arabic2hindi(text);
        }
    },
    computed: {
        yellow () {
            return "#FFC145";
        },
        green () {
            return "#7CB1A9";
        },
        red () {
            return "#FB4952";
        },
        canEditCards () {
            return this.$store.getters.userInfo.editCards
        },
        canEditStacks () {
            return this.$store.getters.userInfo.editStacks
        },
        canEditCardsets () {
            return this.$store.getters.userInfo.editCardsets
        },
        yesOrNo(bool) {
            if (bool)
                return this.$t('text.yes');
            return this.$t('text.no');
        },
        classButtonRight () {
            if (this.$store.state.lang === 'ar')
                return 'button-left';
            return 'button-right';
        }
    }
}
